// Service API
import authLoginService from '@/app/services/auth/auth-login/auth-login-service.js';
import userService from '@/app/services/main/user/user-service.js';

// Util
import { vuelidateUtil } from '@/utils/vuelidate-util.js';

// Constants
import { STATUS_CODES, STATUS_MSG, ERROR_MSG } from '@/app/constants/constants.js';

export default {
	name: 'AuthLogin',
	data() {
		return {
			email: '',
			password: '',
			showPassword: false,
			isAPILoading: false,
			roles:['SADM','LADM']
		}
	},
	computed: {
		validationRules() {
			let fields = {
				email: {},
				password: {}
			}
			fields = vuelidateUtil.setFieldsRequired(fields, true);
			fields = vuelidateUtil.setEmailValidation(fields, 'email');
			return fields;
		},
		authStatus() {
			return this.$store.getters.getAuthMessage;
		}
	},
	methods: {
		onSignIn() {
			this.isAPILoading = true;

			const authDetails = {
				email: this.email,
				password: this.password
			};

			this.commitAuthMessage('', '');

			// auth service login api
			authLoginService.putAuthLogin(authDetails)
				.then(res => {
					if (res.data.status === STATUS_MSG.AUTH_SERVICE_STATUS_SUCCESS_MSG) {
						// Save JWT to lmdc-user store
						this.$store.commit('setUserToken', res.data.jwt);
						// lmdc get logged in user api
						userService.getLoggedInUser(this.email)
							.then(async resp => {
								if (resp.status === STATUS_CODES.SUCCESS) {
									const { userDetails } = resp.data;

									if (!this.roles.includes(userDetails.userRole)) {
										this.isAPILoading = false;
										this.commitAuthMessage('failed', 'You are not authorized to access this site.');
										this.$store.commit('clearUserToken');
										return;
									}

									this.$store.commit('setUserDetails', userDetails);
									this.$store.dispatch('initializeLogoutTimer');
									
									this.isAPILoading = false;

									const routeReferrer = this.$route.query.from;
									if (routeReferrer) {
										this.$router.push(routeReferrer);
									} else {
										this.$router.push('/users');
									}
								} else {
									this.$store.commit('clearUserToken');
									this.isAPILoading = false;
									this.commitAuthMessage('failed', this.getErrorMessage(res));
								}
							})
					} else {
						this.isAPILoading = false;
						this.commitAuthMessage('failed', res.data.message);
					}
				});
		},
		getErrorMessage(res) {
			let message = '';

			if (res.status === STATUS_CODES.BAD_REQUEST || res.status === STATUS_CODES.UNAUTHORIZED) {
				message = res.data.errors[0].message;
			} else {
				message = ERROR_MSG.INTERNAL_ERROR;
			}

			return message;
		},
		commitAuthMessage(status, message) {
			this.$store.commit('setAuthMessage', {status, message});
		},
		setShowPassword() {
			this.showPassword = !this.showPassword;
		}
	},
	validations() {
		return this.validationRules;
	}
}